import { useState, useEffect, useCallback } from 'react';
import { listarConsolidados } from '../services/controlProduccionConsolidados.services';

// Hook: consolidados guardados de una lavandería para un año.
export const useConsolidadosAnio = ({ idLavanderia, year, enabled = true }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !year) return;
    setLoading(true);
    setError(null);
    try {
      setData(await listarConsolidados({ laundryId: idLavanderia, year }));
    } catch (e) {
      setError(e.message || 'Error al cargar los consolidados');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, year, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
